import { render, staticRenderFns } from "./Love.vue?vue&type=template&id=36448d1a&scoped=true&"
import script from "./Love.vue?vue&type=script&lang=js&"
export * from "./Love.vue?vue&type=script&lang=js&"
import style0 from "./Love.vue?vue&type=style&index=0&id=36448d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36448d1a",
  null
  
)

export default component.exports